export default {
  primary: {
    main: "#ecb05f",
    dark: "#a17031"
  },
  neutral: {
    main: "#202020"
  }
};
